import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { ArrayField } from '../fields/ArrayField/ArrayField';
import { BooleanField } from '../fields/BooleanField';
import { DisabledField } from '../fields/DisabledField';
import { EnumField } from '../fields/EnumField';
import { AllOfField } from '../fields/ObjectField/AllOfField';
import { ObjectField } from '../fields/ObjectField/ObjectField';
import { OneOfField } from '../fields/OneOfField/OneOfField';
import { PasswordField } from '../fields/PasswordField';
import { PropertiesField } from '../fields/PropertiesField/PropertiesField';
import { StringField } from '../fields/StringField';
import { TextAreaField } from '../fields/TextAreaField';
import { FormComponentFactoryContext, } from './context/form-component-factory-context';
export const FormComponentFactoryProvider = ({ customFieldsFactory, children, }) => {
    const factory = useCallback((schema) => {
        var _a;
        const CustomField = customFieldsFactory === null || customFieldsFactory === void 0 ? void 0 : customFieldsFactory(schema);
        if (CustomField) {
            return CustomField;
        }
        if (schema.format === 'password') {
            return PasswordField;
        }
        else if (schema.type === 'string' && schema.title && TEXT_AREA_PROPERTY_NAMES.includes(schema.title)) {
            return TextAreaField;
        }
        else if (schema.type === 'string' && Array.isArray(schema.enum)) {
            return EnumField;
        }
        else if (schema.type === 'object' && Object.keys((_a = schema === null || schema === void 0 ? void 0 : schema.properties) !== null && _a !== void 0 ? _a : {}).length === 0) {
            return PropertiesField;
        }
        switch (schema.type) {
            case 'string':
            case 'number':
            case 'integer':
                return StringField;
            case 'boolean':
                return BooleanField;
            case 'object':
                return ObjectField;
            case 'array':
                return ArrayField;
        }
        if (Array.isArray(schema.oneOf)) {
            return OneOfField;
        }
        else if (Array.isArray(schema.allOf)) {
            return AllOfField;
        }
        else if (Array.isArray(schema.anyOf)) {
            throw new Error('FormComponentFactoryProvider: AnyOf should be handled in the scope of the ObjectField');
        }
        return DisabledField;
    }, [customFieldsFactory]);
    return _jsx(FormComponentFactoryContext.Provider, { value: factory, children: children });
};
const TEXT_AREA_PROPERTY_NAMES = ['Expression', 'Description', 'Query', 'Script'];
//# sourceMappingURL=FormComponentFactoryProvider.js.map